import { TrackedEventGroup } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

export const countEvents = (groups: TrackedEventGroup[]): number =>
    groups.reduce((total, group) => total + group.eventLabels.length, 0);

export const formatGroupsForTooltip = (groups: TrackedEventGroup[]): string =>
    groups.map((group) => `${group.deviceTypeName}: ${group.eventLabels.join(', ')}`).join(' | ');
